module.exports = __webpack_public_path__ + "img/Group 107(2).28c19aca.svg";